import React from 'react';

export function NoWrap({ style, children, ...props }) {
  return (
    <span style={{ whiteSpace: 'nowrap', ...style }} {...props}>
      {children}
    </span>
  );
}
